export default{
    async getTerms(){
        let result = null;
        await this.$axios.$get(
            this.$api.common.getTerms
        )
        .then(response => {
            result = response;
        })
        .catch(error => {
        })
        return result;
    },

    async agreeTerms({}){
        let result = null;
        await this.$axios.$post(
            this.$api.common.agreeTerms,
            {}
        )
        .then(response => {
            result = response;
        })
        .catch(error => {
            this.$auth.logout();
        })
        return result;
    }
}